import { Stack, Typography, Badge, Box } from '@mui/material';
import { GameStatus } from '../../../constants/gameConstants';
import ScoreBox from './scoreBox';
import ColorDot from '../colorDot';
import { useSelector } from 'react-redux';
import ColorLine from '../colorDot/colorLine';

const TeamEndScore = ({ team, game }) => {
  const currentSet = game.sets?.find((set) => set.id === game.currentSet);
  const selectedEvent = useSelector((state) => state.event.event);

  const getEndScoreForCurrentSet = (team) => {
    let score = 0;
    if (currentSet) {
      //Calculate all end scores for the team
      const scores = Array.isArray(currentSet.scores) ? currentSet.scores : [];
      for (let i = 0; i < scores.length; i++) {
        const end = scores[i];
        if (end.teamScores?.[team]) {
          score += end.teamScores[team];
        }
      }
    }

    return score;
  };

  const getEndScoreOverSets = (teamId) => {
    let score = 0;

    //Calculate all end scores for the team over all sets
    for (let j = 0; j < game.sets.length; j++) {
      const set = game.sets[j];
      for (let i = 0; i < set.scores.length; i++) {
        const end = set.scores[i];
        if (end.teamScores[teamId]) {
          score += end.teamScores[teamId];
        }
      }
    }

    return score;
  };

  const getGroupNameFromEvent = (teamGroupId) => {
    if (!selectedEvent || !selectedEvent.teamGroups) return null;
    const group = selectedEvent.teamGroups.find((g) => g.id === teamGroupId);
    return group ? group.name : null;
  };

  const getEndScore = (team) => {
    // if (game.gameFormat.setAsSkin) {
    // return getEndScoreOverSets(team);
    // } else {
    return getEndScoreForCurrentSet(team);
    // }
  };

  // Get the team handicaps from event
  const getTeamHandicap = (teamId) => {
    if (!selectedEvent) return 0;

    const team = selectedEvent.teams.find((t) => t.id === teamId);
    if (!team) return 0;

    //Sum all handicaps for the team members
    const handicap = team.members.reduce((acc, member) => {
      if (member && member.handicap) {
        return acc + member.handicap;
      }
      return acc;
    }, 0);

    return handicap ? handicap : 0;
  };

  const useTeamName = team.name !== 'Team 1' && team.name !== 'Team 2' && team.name;

  const teamName = useTeamName
    ? team.name
    : team.players
        .map((player) => {
          if (team.players.length > 2) {
            return player.split(' ')[0].charAt(0) + '. ' + player.split(' ')[1];
          } else {
            return player;
          }
        })
        .join(', ');

  return (
    <Box
      display="flex"
      flexDirection={'column'}
      alignItems="center"
      sx={{ minWidth: 0, maxWidth: '100%' }}>
      <ColorLine color={team.color} />
      <Stack
        px={{ xs: 0.5, sm: 3 }}
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ minWidth: 0, maxWidth: '100%' }}>
        <Typography variant="caption" textAlign="center" sx={{ overflowWrap: 'anywhere' }}>
          {teamName}
        </Typography>
        {team.teamGroupId && (
          <Typography
            variant="caption"
            fontSize={'0.6em'}
            color={team.color}
            textAlign="center"
            sx={{ overflowWrap: 'anywhere' }}>
            {getGroupNameFromEvent(team.teamGroupId)}
          </Typography>
        )}
        {game.status === GameStatus.IN_PROGRESS && currentSet?.isDone ? (
          currentSet.winningId ? (
            <ScoreBox
              teamTotal={game.teamTotals?.[team.id]}
              score={getEndScore(team.id)}
              emoji={currentSet.winningId === team.id ? '🏆' : '🥈'}
            />
          ) : (
            <ScoreBox teamTotal={game.teamTotals?.[team.id]} score={getEndScore(team.id)} />
          )
        ) : null}

        {game.status === GameStatus.COMPLETE && (
          <ScoreBox
            teamTotal={game.teamTotals?.[team.id]}
            score={game.teamTotals?.[team.id]}
            emoji={game.winningTeamId === team.id ? '🏆' : '🥈'}
          />
        )}

        {game.status === GameStatus.PLAYOFF && game.playoff && (
          <ScoreBox
            teamTotal={game.teamTotals?.[team.id]}
            score={game.playoff.teamScores?.[team.id]}
          />
        )}

        {game.status === GameStatus.IN_PROGRESS && !currentSet?.isDone && (
          <ScoreBox teamTotal={game.teamTotals?.[team.id]} score={getEndScore(team.id)} />
        )}
      </Stack>
    </Box>
  );
};

export default TeamEndScore;
/* aaaaa */
